module.exports = __webpack_public_path__ + "img/China.017aa75a.svg";